// extracted by mini-css-extract-plugin
module.exports = {"inputMain":"Blog_inputMain__2d-0Z","searchIcon":"Blog_searchIcon__31AOP","description":"Blog_description__1HVPV","descDiv":"Blog_descDiv__3LI4Q"};